<template>
  <div style="position: relative" :style="{ minHeight: height + 'px' }">
    <a-spin class="chart-loading" tip="加载中..." :spinning="loadingChart" />
    <div v-if="!loadingChart && data.length > 0">
      <div class="title-container">
        <!-- 标题改变 -->
        <h4 :style="{ margin: '0 0 20px 20px', ...titleStyle }" :class="titleClass">{{ title }}</h4>
        <a-button v-if="showReturnBtn" type="primary" @click="handleReturn">返回上级</a-button>
        <slot name="titleExtra"></slot>
      </div>
      <v-chart
        v-if="isShowGuide"
        :force-fit="true"
        :height="height"
        :data="data"
        :scale="scale"
        style="position: relative; z-index: 1"
      >
        <v-tooltip />
        <v-axis />
        <v-legend />
        <v-smooth-line position="type*y" color="x" />
        <v-point
          position="type*y"
          color="x"
          :size="4"
          :v-style="style"
          :shape="'circle'"
          :onClick="pointChartClick"
        />
        <v-guide
          v-for="(item, index) in guideEventList"
          :key="index"
          type="image"
          :src="guideEventImg"
          :width="20"
          :height="20"
          :offsetX="-12"
          :offsetY="-30"
          :top="true"
          :zIndex="9999"
          :start="item.position"
          :end="item.position"
          v-bind="guideConfig"
        />
        <v-guide
          v-for="(item, index) in guideWarntList"
          :key="index"
          type="image"
          :src="guideWarnImg"
          :width="20"
          :height="20"
          :offsetX="-13"
          :offsetY="-30"
          :top="true"
          :zIndex="9999"
          :start="item.position"
          :end="item.position"
          v-bind="guideConfig"
        />
        <v-guide
          v-for="(item, index) in guideMoreEventList"
          :key="index"
          type="image"
          :src="guideMoreEventImg"
          :width="20"
          :height="20"
          :offsetX="-13"
          :offsetY="-30"
          :top="true"
          :zIndex="9999"
          :start="item.position"
          :end="item.position"
          v-bind="guideConfig"
        />
      </v-chart>
      <div>
        <div
          class="tip-modal animate__animated animate__bounceIn"
          v-if="tipStatus"
          :style="tipStyle"
        >
          <!-- 具名插槽 -->
          <slot name="guideTipModal" :record="guideTipList">
            <div
              v-for="(item, index) in guideTipList"
              :key="index"
              style="width: 100%; margin-bottom: 10px"
            >
              <div class="tip-head">
                <span class="tip-title" :class="item.type == 'warn' ? 'warn-title' : ''">
                  {{ item.title }}
                </span>
                <span class="tip-time">{{ item.time }}</span>
              </div>
              <div class="tip-desc">{{ item.desc }}</div>
            </div>
          </slot>
        </div>
        <div v-if="tipStatus" class="tip-mask" @click="() => (tipStatus = false)">关闭</div>
      </div>
    </div>
    <div
      v-else-if="!loadingChart && data.length == 0 && isShowNoDataIcon"
      class="chart-loading"
      style="font-size: 16px; text-align: center; color: #ccc"
    >
      <div>
        <img style="width: 100px; height: 80px" :src="require('@assets/nodata.png')" alt="" />
        <div>暂无数据</div>
      </div>
    </div>
  </div>
</template>

<script>
import { DataSet } from '@antv/data-set'
import { ChartEventMixins } from './mixins/ChartMixins'
import { getAction } from '@api/manage'
import { mapArrFiledKey, saveFieldsArrKey, strToGroup, sortArrObj } from '@/utils/util'
import moment from 'moment'
import { simpleDebounce } from '@/utils/util'

export default {
  name: 'SmoothLineChartMultid',
  mixins: [ChartEventMixins],
  props: {
    title: {
      type: String,
      default: '',
    },
    dataSource: {
      type: Array,
      default: () => [],
    },
    fields: {
      type: Array,
      default: () => [],
    },
    // 别名，需要的格式：[{field:'name',alias:'姓名'}, {field:'sex',alias:'性别'}]
    aliases: {
      type: Array,
      default: () => [],
    },
    height: {
      type: Number,
      default: 400,
    },
    showReturnBtn: {
      type: Boolean,
      default: false,
    },
    titleStyle: {
      type: Object,
      default: () => ({}),
    },
    guideEventImg: {
      type: String,
      default: require('@assets/schoolChangeTrend/position-icon.png'),
    },
    guideWarnImg: {
      type: String,
      default: require('@assets/schoolChangeTrend/warn-icon.png'),
    },
    guideMoreEventImg: {
      type: String,
      default: require('@assets/schoolChangeTrend/more-event.png'),
    },
    guideConfig: {
      type: Object,
      default: () => ({}),
    },
    yAxisMultiple: {
      type: Number,
      default: 1,
    },
    isWatchGuide: {
      // 监听标注变化限制，添加标注，必须要添加这个
      type: Boolean,
      default: false,
    },
    titleClass: {
      type: String,
      default: '',
    },
    loadingChart: {
      type: Boolean,
      default: false,
    },
    isShowNoDataIcon: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      style: { stroke: '#fff', lineWidth: 1 },
      scale: [
        {
          dataKey: 'y',
        },
        {
          dataKey: 'type',
          type: 'timeCat',
        },
      ],
      dataTmp: [
        ['2024-09-14', 25.5],
        ['2024-09-15', 25.5],
        ['2024-09-16', 20.5],
      ],
      countTmp: 0,
      guideEventList: [],
      guideWarntList: [],
      guideMoreEventList: [],
      isShowGuide: true, // 是否显示标注图片
      tipStatus: false,
      tipStyle: {
        width: '142px',
        minHeight: '74px',
        position: 'absolute',
        background: '#fff',
        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.2)',
        padding: '10px',
        cursor: 'pointer',
        zIndex: 999,
        borderRadius: '4px',
      },
      eventsTypeOpts: [
        {
          label: '心理辅导',
          value: 1,
        },
        {
          label: '班级考试',
          value: 2,
        },
        {
          label: '班级活动',
          value: 3,
        },
        {
          label: '年级活动',
          value: 4,
        },
        {
          label: '校园活动',
          value: 5,
        },
        {
          label: '工作会议',
          value: 6,
        },
        {
          label: '其他',
          value: 7,
        },
      ],
      guideTipList: [],
      dataSourceRecord: [],
      filedRecord: [],
      windowViewWidth: 0,
    }
  },
  watch: {
    dataSource: {
      async handler(newValue) {
        this.isShowGuide = false
        await this.$nextTick()
        this.getguidePosList(newValue)
        this.isShowGuide = true
      },
      deep: true, // 开启深度监听
      immediate: true, // 立即执行一次
    },
  },
  computed: {
    data() {
      // console.log('折线图computed监听--')

      const dv = new DataSet.View().source(this.dataSource)

      this.filedRecord = [...this.fields]

      dv.transform({
        type: 'fold',
        fields: this.fields,
        key: 'x',
        value: 'y',
      })

      let rows = dv.rows
      this.setYMax(rows)

      // 替换别名
      rows.forEach((row) => {
        for (let item of this.aliases) {
          if (item.field === row.x) {
            row.x = item.alias
            break
          }
        }
      })
      return rows
    },
  },
  mounted() {
    this.updateWindomView()
    window.addEventListener('resize', this.updateWindomView)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateWindomView)
  },
  methods: {
    updateWindomView: simpleDebounce(function () {
      this.windowViewWidth = window.innerWidth
      console.log('浏览器视窗变化--', this.windowViewWidth)
    }, 500),
    async pointChartClick(record) {
      const pointData = record.data._origin
      const incidentStatus = pointData[pointData.x + 'incident'] == 1
      const warnStatus = pointData[pointData.x + 'warn'] == 1
      console.log('点信息：', record)

      if (incidentStatus && warnStatus) {
        const eventList = await this.getGuideEventTip(pointData[pointData.x + 'id'])
        const warnList = await this.getGuideWarnTip(pointData[pointData.x + 'id'], pointData.type)
        this.tipStatus = true
        // console.log('时间排序：', sortArrObj([...eventList, ...warnList]))

        this.guideTipList = [...eventList, ...warnList]
      } else if (incidentStatus) {
        this.guideTipList = await this.getGuideEventTip(pointData[pointData.x + 'id'])
        this.tipStatus = true
      } else if (warnStatus) {
        this.guideTipList = await this.getGuideWarnTip(
          pointData[pointData.x + 'id'],
          pointData.type
        )
        this.tipStatus = true
      }

      // console.log('点位置变化：', record.x + 400)
      // console.log('变化this.windowViewWidth--', this.windowViewWidth)

      if (record.x + 500 >= this.windowViewWidth && this.windowViewWidth != 0) {
        this.$set(this.tipStyle, 'left', record.x - 120 + 'px')
        this.$set(this.tipStyle, 'top', record.y + 'px')
      } else {
        this.$set(this.tipStyle, 'left', record.x + 20 + 'px')
        this.$set(this.tipStyle, 'top', record.y + 'px')
      }
      this.$emit('pointChartClick')
    },
    // 设置y轴最大值，防止图标标注溢出
    setYMax(rows) {
      this.tipStatus = false
      if (!rows && !this.guideEventList.length) {
        // 清楚掉min和max属性
        this.$set(this.scale[0], 'max', undefined)
        this.$set(this.scale[0], 'min', undefined)
        return
      }
      if (rows && rows.length && this.yAxisMultiple > 1 && this.guideEventList.length) {
        const maxYValue = Math.max(...rows.map((item) => item.y || 0))
        this.$set(this.scale[0], 'max', maxYValue * this.yAxisMultiple)
        this.$set(this.scale[0], 'min', 0)
      }
    },
    async getguidePosList(data) {
      console.log('折线图数据源变化--', data)
      // 更新视图dom
      const { incidentList, warnList, moreEvList } = mapArrFiledKey(data)
      this.guideEventList = incidentList
      this.guideWarntList = warnList
      this.guideMoreEventList = moreEvList
      console.log('事件-位置列表：', this.guideEventList)
      console.log('提醒-位置列表：', this.guideWarntList)
      console.log('多事件-位置列表：', this.guideMoreEventList)
      this.setYMax()
    },
    async getGuideEventTip(id) {
      const res = await getAction('/dataEvents/queryById', { id })
      const mapTipData =
        res.success && res.result.length
          ? res.result.map((item) => {
              return {
                title: this.eventsTypeOpts.find((opt) => opt.value === item.eventsType).label,
                time: moment(item.createTime).format('HH:mm:ss'),
                desc: item.eventsContent,
                type: 'event',
              }
            })
          : []
      return mapTipData
    },
    async getGuideWarnTip(id, time) {
      console.log('id信息--', id, time)
      const res = await getAction('/rector/moodRecordAndWarnRecord', {
        studentId: id,
        time,
        pageNo: 1,
        pageSize: 10,
        userIdentity: 1,
        type: 0,
        dataType: 1,
      })
      const mapTipData =
        res.success && res.result.records.length
          ? res.result.records.map((item) => {
              return {
                title: '提醒时间',
                time: moment(item.dateStr).format('HH:mm:ss'),
                desc: item.comment,
                type: 'warn',
              }
            })
          : []
      console.log('提醒信息处理：', mapTipData)
      return mapTipData
    },
    // 图例点击
    legendClick(record) {
      // console.log('点击图例：', record)
      // const currLegend = record.item.value
      // const currLegendIndex = this.fields.indexOf(currLegend)
      // if (record.checked && !this.filedRecord.includes(currLegend)) {
      //   this.filedRecord.splice(currLegendIndex, 0, currLegend)
      // } else {
      //   this.filedRecord.splice(currLegendIndex, 1)
      // }
      // this.dataSourceRecord = saveFieldsArrKey(this.dataSource, this.filedRecord, [
      //   'id',
      //   'incident',
      //   'warn',
      // ])
      // console.log('数据源记录：', this.dataSourceRecord)
      // console.log('图例记录：', this.filedRecord)
      // const keys = Object.keys(this.dataSourceRecord[0]).filter(
      //   (key) => key.includes('incident') || key.includes('warn')
      // )
      // // console.log('包含incident或warn的字段--', keys)
      // const groundArrObj = strToGroup(keys)
      // // console.log('分组对象--', groundArrObj)
      // const moreEvList = []
      // const incidentList = []
      // const warnList = []
      // if (keys.length) {
      //   this.dataSourceRecord.forEach((item) => {
      //     groundArrObj.forEach((obj) => {
      //       const position = [item.type, item[obj.field]]
      //       const id = item[obj.field + 'id']
      //       if (item[obj.incident] == 1 && item[obj.warn] == 1) {
      //         moreEvList.push({ position, id })
      //       } else if (item[obj.incident] == 1) {
      //         incidentList.push({ position, id })
      //       } else if (item[obj.warn] == 1) {
      //         warnList.push({ position, id })
      //       }
      //     })
      //   })
      // }
      // this.guideEventList = incidentList
      // this.guideWarntList = warnList
      // this.guideMoreEventList = moreEvList
      // this.title = '滴滴滴滴'
      // this.getguidePosList(this.dataSourceRecord)
    },
  },
}
</script>

<style scoped lang="less">
.tip-modal {
  min-width: 200px;
}
.chart-loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.tip-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.tip-title {
  font-size: 14px;
  display: inline-block;
  color: #fff;
  background: #13b999;
  padding: 0 4px;
  border-radius: 4px;
  font-size: 12px;
}
.warn-title {
  background: #fa3a25;
}
.tip-time {
  font-size: 12px;
}
.tip-desc {
  width: 100%;
  margin-top: 6px;
  display: inline-block;
  font-size: 12px;
  white-space: wrap;
  word-wrap: break-word;
}
.tip-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: transparent;
  z-index: 99;
}
.title-container {
  display: flex;
  // align-items: center;
  justify-content: space-between;
}
</style>
